const yup = require('yup')
const { DateTime } = require('luxon')
const { uploadSchema } = require('./cloudinary-schema')
const { requiredFields, labelify } = require('./helpers')

const shape = labelify({
  _id: yup.mixed(),
  title: yup.string().max(100).meta({ maxLength: 100 }).default(''),
  body: yup.string().max(240).meta({ maxLength: 240 }).ensure(),
  image: uploadSchema,
  published: yup.boolean().nullable().default(true),
  startAt: yup.date().when('published', {
    is: true,
    then: yup
      .date()
      .required(),
  }),
  endAt: yup
    .date()
    .when('published', {
      is: true,
      then: yup
        .date()
        .required()
        .min(yup.ref('startAt'), 'End time must be after the start time'),
    })
    .min(yup.ref('startAt')),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const mobileWelcomeSchemaPartial = yup.object().shape(shape)
const mobileWelcomeSchema = mobileWelcomeSchemaPartial.shape(requiredFields(['title', 'body'])(shape))

const mobileWelcomeFormSchema = mobileWelcomeSchema.shape({
  startAt: yup.mixed().datetime(),
  endAt: yup.mixed().datetime(() => DateTime.local().plus({ hour: 1 })),
})

module.exports = { mobileWelcomeSchema, mobileWelcomeSchemaPartial, mobileWelcomeFormSchema }
